import RightArrow from "@uui/ChevronRight";
import { To } from "react-router-dom";

import { CheckboxProps, FormControlLabel, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Button from "@rui/Button";
import Checkbox from "@rui/Checkbox";
import Link from "@rui/Link";
import { Column } from "@rui/Stack";

export const OpenButton = styled(Button)(({ theme }) => ({
  position: "fixed",
  bottom: "16px",
  zIndex: 100,
  backgroundColor: theme.palette.shades.secondary[600],
  transition: "left 0.1s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.shades.secondary[700],
  },
  "&:active": {
    backgroundColor: theme.palette.shades.secondary[800],
  },
  "& span": {
    color: theme.palette.transparent.white[70],
    paddingLeft: "4px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  "& span": {
    color: theme.palette.shades.neutral[300],
  },
}));

export const ChecklistBox = styled(Column)({
  position: "fixed",
  background: "white",
  zIndex: 101,
  width: "300px",
  minHeight: "330px",
  boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.10)",
  borderRadius: "8px",
});

const ChecklistItemWrapper = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingRight: "4px",
  cursor: "pointer",
  transition: "background-color 0.1s ease-in-out",
  borderRadius: "4px",

  "&:hover": {
    backgroundColor: theme.palette.shades.ghost[400],
  },

  "& > .MuiSvgIcon-root": {
    opacity: 0,
    color: theme.palette.shades.primary[500],
    transition: "opacity 0.1s ease-in-out",
    width: "18px",
  },
  "&:hover > .MuiSvgIcon-root": {
    opacity: 1,
  },
  "&:active > .MuiSvgIcon-root": {
    color: theme.palette.shades.primary[600],
  },
}));

export const ChecklistItem = styled(
  ({
    label,
    className,
    to,
    checked,
    ...props
  }: CheckboxProps & { label: string; to: To }) => {
    return (
      <ChecklistItemWrapper to={to}>
        <FormControlLabel
          className={className}
          control={<Checkbox variant="filled" checked={checked} {...props} />}
          label={label}
        />
        {checked ? null : <RightArrow />}
      </ChecklistItemWrapper>
    );
  }
)(({ theme }) => ({
  marginLeft: "0",
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    fontWeight: "500",
    color: theme.palette.shades.neutral[700],
  },
  "& .MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label": {
    textDecoration: "line-through",
    fontWeight: "400",
    color: theme.palette.shades.neutral[500],
  },
}));
